/** Bill line is a top-level sellable row (not nested under a combo). */
export function isStandaloneBillLine(line) {
  return Boolean(line) && !line.is_combo_component && !line.parent_line_id;
}

/** Prefer the newest standalone line when the same menu item exists as a combo component. */
export function findStandaloneBillLine(lines, menuItemId) {
  return [...(lines || [])]
    .filter((l) => l.menu_item_id === menuItemId && isStandaloneBillLine(l))
    .sort((a, b) => (b.sort_order ?? b.id) - (a.sort_order ?? a.id))[0] ?? null;
}

/** Resolve line id used for qty / void actions (combo children map to header). */
export function billLineActionId(line) {
  if (!line) return null;
  if (line.is_combo_component && line.parent_line_id) return line.parent_line_id;
  return line.id;
}

/** Annotate lines for POS-style grids: serial numbers skip combo children. */
export function annotateBillLinesForDisplay(lines = []) {
  let serial = 0;

  return lines.map((line, index) => {
    const isComboChild = Boolean(line.is_combo_component || line.parent_line_id);
    const isComboHeader = Boolean(line.is_combo_header);
    if (!isComboChild) serial += 1;

    const prev = lines[index - 1];
    const prevInCombo = prev && (prev.is_combo_component || prev.parent_line_id);
    const showComboGap = !isComboChild && !isComboHeader && prevInCombo;

    return {
      line,
      serial: isComboChild ? null : serial,
      isComboChild,
      isComboHeader,
      showComboGap,
    };
  });
}
